import { createIcon } from '~/utils';

export const MailIcon = createIcon({
  viewBox: '0 0 16 17',
  path: (
    <path d='M14 3.5H2C1.86739 3.5 1.74021 3.55268 1.64645 3.64645C1.55268 3.74021 1.5 3.86739 1.5 4V12.5C1.5 12.7652 1.60536 13.0196 1.79289 13.2071C1.98043 13.3946 2.23478 13.5 2.5 13.5H13.5C13.7652 13.5 14.0196 13.3946 14.2071 13.2071C14.3946 13.0196 14.5 12.7652 14.5 12.5V4C14.5 3.86739 14.4473 3.74021 14.3536 3.64645C14.2598 3.55268 14.1326 3.5 14 3.5ZM6.16937 8.5L2.5 11.8631V5.13688L6.16937 8.5ZM6.90938 9.17813L7.65938 9.86875C7.75162 9.95343 7.87228 10.0004 7.9975 10.0004C8.12272 10.0004 8.24338 9.95343 8.33562 9.86875L9.08562 9.17813L12.7106 12.5H3.28562L6.90938 9.17813ZM9.83062 8.5L13.5 5.13625V11.8638L9.83062 8.5Z' />
  ),
});
